import { SearchTermsContent } from "@/components/search-terms";

export default function SearchTerms() {
  return (
    <SearchTermsContent />
  );
}
